import { isAxiosError } from 'axios';
import { API_PAYMENTS_URL } from '@/constants/config';
import { fetch } from '@/utils/fetch';

export interface SplitDetails {
  status: string; // 'PENDING' | 'EXPIRED'
  totalAmount: number;
  remainingAmount: number;
  userPaymentAmount: number;
  type: 'SPLIT_EQUALLY' | 'SPLIT_BY_ITEMS';
  numberOfSplits: number;
  updatedNumberOfSplits: null;
  numberOfPaidSplits: number;
  userTipAmount: number;
  onePersonSplit: number; // TODO use it instead of calculate it
  lockedLineItemIds?: string[];
}

interface Props {
  orderNumber: string;
  signal: AbortSignal;
}
export const isSplitDefined = (
  splitDetails: SplitDetails | { errorCode: number } | undefined | null
): splitDetails is SplitDetails => {
  return !!splitDetails && 'status' in splitDetails;
};

export const getSplitDetails = async ({
  orderNumber,
  signal,
}: Props): Promise<SplitDetails | { errorCode: number }> => {
  try {
    const response = await fetch.get(
      `${API_PAYMENTS_URL}/split-payments?reference=${orderNumber}`,
      { signal }
    );
    return response.data;
  } catch (error: unknown) {
    if (error && isAxiosError(error)) {
      return { errorCode: error?.response?.status || 500 };
    } else {
      return { errorCode: 500 };
    }
  }
};
